import { generateHashCode } from '@src/quince-site-common/src/utils/stringUtil'

import { ExperimentConfiguration } from '../experiments.types'

const getBucketForExperiment = (experiment: ExperimentConfiguration, hashBucket: number) => {
  let curBucketStart = 0
  for (const bucket of experiment.buckets) {
    if (curBucketStart + bucket.ratio > hashBucket) {
      return bucket
    }
    curBucketStart += bucket.ratio
  }
  return experiment.buckets[0]
}

const getExperimentBucketForUser = (experiment: ExperimentConfiguration, userId: string) => {
  const hashStringComponents = [experiment.name, experiment.date, userId]
  if (experiment.ignoreBucketRebucketingHash) {
    hashStringComponents.push(experiment.ignoreBucketRebucketingHash)
  }
  const hashBucket = generateHashCode(hashStringComponents.join('_')) % 100

  const userBucket = getBucketForExperiment(experiment, hashBucket)?.name

  return userBucket
}

export default getExperimentBucketForUser
